.auth-page.animated
  .auth-container.animated
    button(data-hook="flip").btn-back.btn-round
      i.icon.ion-ios-arrow-back
    h1 Hallo!
    .auth-wrap.animated
      .auth-flip
        div(data-hook="login-form")
        div(data-hook="signup-form")
